.carouselContainer {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  border-radius: 8px;
}

.slide {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 8px;
  overflow: hidden;
}

.bannerImg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  display: block;
  pointer-events: none;
  user-select: none;
}

.slideContent {
  color: #fff;
}

.logo {
  max-height: 50px;
  margin-bottom: 8px;
}

.slideLabel {
  font-size: 1.25rem;
  margin: 0;
  color: #fff;
}

.slideIndicator {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  margin-left: 4px;
}

.progressContainer {
  position: absolute;
  padding: 0 16px;
  bottom: 0;
  height: 32px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
}

.progressBar {
  cursor: pointer;
  width: 24px;
  height: 2px;
  background: #fff;
  position: relative;
  border-radius: 1px;
}

.progressFill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: var(--ogm-seahawks);
  animation: fillAnimation linear both;
  will-change: width;
  backface-visibility: hidden;
  border-radius: 1px;
}

@keyframes fillAnimation {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
.gridContainer {
  display: grid;
  padding-left: 8px;
  padding-right: 8px;
  grid-gap: 8px;
  grid-auto-flow: column;
  grid-auto-columns: calc(100vw - 150px);
  padding-top: 1px;
  padding-bottom: 2px;
  overflow-x: scroll;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  border-radius: 8px;
}

.gridItem {
  scroll-snap-align: start;
  aspect-ratio: 3/2;
  position: relative;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .gridContainer {
    grid-auto-columns: calc(50vw - 100px);
  }
}
@media (min-width: 1024px) {
  .slide {
    background-position: top center;
  }
}
